const Constants = {
  /**
   * Get a store placeholder image.
   * @param width
   * @param height
   * @return {string}
   */
  storePlaceholder(width, height) {
    return `https://trek.scene7.com/is/image/TrekBicycleProducts/Store_Placeholder_4x3?wid=${width}&hei=${height}&fit=crop,1`;
  },
};

export {Constants};
